export default "<administration-workspaces-list [initialWorkspaces]=\"initialWorkspaces\"></administration-workspaces-list>\n";